<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:19:22
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-22 16:16:44
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    isTabs
    :footer="footer"
    ref="table"
  >
    <template #componentContainer="{height}">
      <div id="dom" style="width:100%" :style="{ height: height + 'px' }"></div>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import echarts from "echarts";
import { apis } from "@/api/analysis/financialRevenue";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => {
        if (t.includes) {
          return t.includes.includes(this.name);
        } else return true;
      })
    );
    this.myChart = echarts.init(document.getElementById("dom"));
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
    setTimeout(() => {
      this.myChart.resize();
    }, 100);
    // 绘制图表
  },
  data() {
    return {
      myChart: null,
      methods: {
        ...apis,
        list: p => {
          return this.data.list(p);
        },
        beforeHandleList: ({ data, list }) => {
          console.log(data);
          this.myChart.resize();
          this.myChart.setOption({
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999"
                }
              }
            },
            dataZoom: [
              {
                show: true
              }
            ],
            legend: {},
            xAxis: {
              type: "category",
              data: data.report_date,
              axisPointer: {
                type: "shadow"
              }
            },
            yAxis: {},
            series: [
              {
                name: this.$tz("单量"),
                type: "bar",
                data: data.num,
                label: {
                  show: true,
                  position: "top"
                }
              },
              {
                name: this.$tz("人民币,收入"),
                type: "bar",
                data: data.cny
              },
              {
                name: this.$tz("美金,收入"),
                type: "bar",
                data: data.usd
              }
            ]
          });
          return [];
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: []
    };
  }
};
</script>

<style scoped></style>
